import { request } from './http'
import type { Character, CharacterInput } from '@/types/nf'

const projectPath = (projectId: string) => `/v1/projects/${encodeURIComponent(projectId)}/characters`
const characterPath = (projectId: string, characterId: string) =>
  `${projectPath(projectId)}/${encodeURIComponent(characterId)}`

export const characterApi = {
  list: (projectId: string): Promise<Character[]> => request<Character[]>(projectPath(projectId)),

  create: (projectId: string, body: CharacterInput): Promise<Character> =>
    request<Character>(projectPath(projectId), { method: 'POST', body }),

  get: (projectId: string, characterId: string): Promise<Character> =>
    request<Character>(characterPath(projectId, characterId)),

  update: (projectId: string, characterId: string, body: CharacterInput): Promise<Character> =>
    request<Character>(characterPath(projectId, characterId), { method: 'PATCH', body }),

  delete: (projectId: string, characterId: string): Promise<void> =>
    request<void>(characterPath(projectId, characterId), { method: 'DELETE' }),
}
